import {EntryShared, socket, uiManagerEvents, setUIManagerEvents} from '../shared/scripts/EntryShared'
import {SocketWebActionController} from './scripts/SocketActionController'
import {UIWHeaderController} from './scripts/ui_html/header/UIWHeaderController'
import {UIWGeneralServicesController} from './scripts/UIWGeneralServicesController'
import {UINotificationSendHelper} from '../shared/scripts/notifications/UINotificationSendHelper'
import {UIWNotificationController} from './scripts/notifications/UIWNotificationController'
import {UIWManagerEvents} from './scripts/ui_html/UIWManagerEvents'

export class EntrySingletonPageShared {
    static initializeSocketAndGeneralServices(headerController: UIWHeaderController | undefined) {
        if(uiManagerEvents == undefined) setUIManagerEvents(new UIWManagerEvents(undefined))
        const generalServicesController = new UIWGeneralServicesController(undefined, headerController)
        const socketActionController = new SocketWebActionController(undefined, undefined, generalServicesController)
        EntryShared.initializeSocket(socketActionController)
        EntryShared.initializeNotification(new UIWNotificationController())

        socket.connect()

        generalServicesController.init()

        UINotificationSendHelper.init()
    }
}
